import {configFactory} from './di/modules/di.infa-init';
import {Application} from 'pixi.js';

import {apiRoutes, clientRoutes} from '@/constants';
import {envs} from '@/envs';

export type ClientRoutes = typeof clientRoutes;
export type ApiRoutes = typeof apiRoutes;
export type Envs = typeof envs;
export type GlobalWindow = typeof globalThis.window & {__PIXI_APP__?: Application};

export type Platform = 'web' | 'mb';
export type PlatformVersion = string | null;
export type ISOString = string; // 2023-02-21T15:18:28.530Z
export type TimeToConfig = {
  seconds?: number;
  minutes?: number;
  hours?: number;
  days?: number;
};

export type Config = ReturnType<typeof configFactory>;

export enum StatisticItemContentType {
  Title1 = 'title1',
  Description1 = 'description1',
  Description2 = 'description2',
}

export enum StatisticItemParamType {
  String = 'string',
  Number = 'number',
}

export enum StatisticItemValidationType {
  NonNegative = 'nonNegative',
  Integer = 'integer',
  MoreThanValue = 'MoreThanValue',
  LessThanValue = 'LessThanValue',
  SignsAfterComma = 'signsAfterComma',
  MaxStringLength = 'maxStringLength',
  MinStringLength = 'minStringLength',
  UpperCaseString = 'upperCaseString',
  BlackListString = 'blackListString',
  DayMonthDate = 'dayMonthDate',
  MonthDate = 'monthDate',
  Seconds = 'seconds',
  WhiteListNumber = 'whiteListNumber',
  RoundNumber = 'roundNumber',
}

export enum BonusRedirectType {
  Bonuses = 'bonuses',
  Main = 'main',
}

export type NamedItem<T extends object> = T & {name: string};

export enum MB_PLATFORMS {
  ios = 'ios',
  android = 'android',
}

export type MIN_VERSIONS_MB_TYPE = {
  [key: string]: {
    [key in MB_PLATFORMS]: string;
  };
};
